(function () {
  /* DFNDR notify v6 — universal single-variant signup.
     One color + one size (single-select) -> one variant -> one Klaviyo
     back-in-stock subscription -> one notification. Runs on every
     product automatically via the buy-buttons block:
       "coming-soon" tag -> waitlist mode; sold-out variant -> restock mode.
     Singleton, delegated, morph-safe; modal portals to <body>. */
  if (window.__dfndrNotify) return;
  window.__dfndrNotify = 1;

  var COMPANY_ID = 'RgUcrC';
  var LIST_ID = 'Y8e7Ks';
  var REVISION = '2024-10-15';

  var dataByKey = {};
  var stateByKey = {}; /* key -> { sel: { optNameLower: value } } */

  function cta(key) { return document.querySelector('[data-dfndr-notify-open][data-key="' + key + '"]'); }
  function modal(key) { return document.body.querySelector(':scope > [data-dfndr-notify][data-key="' + key + '"]'); }
  function product(key) {
    var d = dataByKey[key];
    return d && d.products && d.products[0] ? d.products[0] : null;
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function isColorName(n) { n = n.toLowerCase(); return n === 'color' || n === 'colour' || n === 'colorway' || n === 'colourway'; }

  function uniqueValues(p, idx) {
    var seen = {}, out = [];
    p.variants.forEach(function (v) { var val = v.o[idx]; if (!seen[val]) { seen[val] = 1; out.push(val); } });
    return out;
  }
  function imageForValue(p, idx, val) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].o[idx] === val && p.variants[i].img) return p.variants[i].img;
    return null;
  }
  function resolve(key) {
    var p = product(key), st = stateByKey[key];
    if (!p || !st) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], hit = true;
      for (var j = 0; j < p.optionNames.length; j++) {
        if (v.o[j] !== st.sel[p.optionNames[j].toLowerCase()]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return null;
  }

  function adopt() {
    document.querySelectorAll('[data-dfndr-notify]').forEach(function (m) {
      if (m.parentElement === document.body) return;
      var key = m.getAttribute('data-key');
      if (modal(key)) { m.remove(); return; }
      document.body.appendChild(m);
    });
    document.querySelectorAll('[data-dfndr-notify-data]').forEach(function (el) {
      var key = el.getAttribute('data-key');
      if (dataByKey[key]) return;
      try { dataByKey[key] = JSON.parse(el.textContent); } catch (e) { dataByKey[key] = { products: [] }; }
    });
  }

  function pdpVariantId(key) {
    var c = cta(key);
    var form = (c && c.closest('form')) || document.querySelector('form[data-type="add-to-cart-form"]');
    var input = (form || document).querySelector('input[name="id"], select[name="id"]');
    return input ? +input.value : null;
  }

  function initState(key) {
    var p = product(key); if (!p) return null;
    if (stateByKey[key]) return stateByKey[key];
    var st = stateByKey[key] = { sel: {} };
    var vid = pdpVariantId(key), pv = null;
    p.variants.forEach(function (v) { if (v.id === vid) pv = v; });
    if (!pv) pv = p.variants[0];
    if (pv) p.optionNames.forEach(function (name, i) { st.sel[name.toLowerCase()] = pv.o[i]; });
    return st;
  }

  function renderModal(key) {
    var m = modal(key), p = product(key);
    if (!m || !p) return;
    var st = initState(key); if (!st) return;

    var opts = m.querySelector('[data-dfndr-notify-opts]');
    opts.innerHTML = p.optionNames.map(function (name, i) {
      var k = name.toLowerCase();
      var color = isColorName(name);
      var row = uniqueValues(p, i).map(function (val) {
        var on = st.sel[k] === val;
        if (color) {
          var img = imageForValue(p, i, val);
          return '<button type="button" class="dfndr-notify__tile' + (on ? ' is-on' : '') +
            '" data-dfndr-opt="' + esc(k) + '" data-dfndr-val="' + esc(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '" aria-pressed="' + on + '">' +
            (img ? '<span class="dfndr-notify__tile-img" style="background-image:url(' + esc(img) + ')"></span>' : '') +
            '<span class="dfndr-notify__tile-label">' + esc(val) + '</span></button>';
        }
        return '<button type="button" class="dfndr-notify__chip dfndr-notify__chip--lg' + (on ? ' is-on' : '') +
          '" data-dfndr-opt="' + esc(k) + '" data-dfndr-val="' + esc(val) + '" aria-pressed="' + on + '">' + esc(val) + '</button>';
      }).join('');
      return '<div class="dfndr-notify__opt"><p class="dfndr-notify__opt-name">' + esc(name.toUpperCase()) +
        '</p><div class="dfndr-notify__opt-row' + (color ? ' dfndr-notify__opt-row--tiles' : '') + '">' + row + '</div></div>';
    }).join('');

    var v = resolve(key);
    var countEl = m.querySelector('[data-dfndr-notify-count]');
    if (countEl) {
      if (v && v.a && !p.coming) {
        countEl.textContent = 'That one\u2019s in stock \u2014 close this and add it to cart.';
      } else if (v) {
        countEl.textContent = 'Signing up for: ' + p.title + ' \u2014 ' + v.o.join(' / ');
      } else {
        countEl.textContent = 'That combination isn\u2019t offered \u2014 adjust your picks.';
      }
      countEl.className = 'dfndr-notify__count' + (v ? '' : ' is-err');
    }
  }

  function atcEls(key) {
    var c = cta(key);
    var root = (c && (c.closest('form') || c.closest('.product-information, section'))) || document;
    return root.querySelectorAll('add-to-cart-component, .add-to-cart, button[name="add"], accelerated-checkout, shopify-accelerated-checkout, .shopify-payment-button');
  }

  function refresh() {
    adopt();
    document.querySelectorAll('[data-dfndr-notify-open]').forEach(function (c) {
      var key = c.getAttribute('data-key');
      var m = modal(key);
      var comingSoon = m && m.getAttribute('data-coming-soon') === 'true';
      var p = product(key);
      var vid = pdpVariantId(key), v = null;
      if (p) p.variants.forEach(function (x) { if (x.id === vid) v = x; });
      if (!v && p) v = p.variants[0];
      var show = comingSoon || (v && !v.a);
      c.hidden = !show;
      if (show) atcEls(key).forEach(function (el) { el.style.setProperty('display', 'none', 'important'); });
    });
    suppressAppButton();
  }

  function suppressAppButton() {
    document.querySelectorAll('.klaviyo-bis-trigger, button, a, div[role="button"]').forEach(function (el) {
      if (el.dataset.dfndrSuppressed) return;
      if (el.closest('[data-dfndr-notify]')) return;
      if (el.hasAttribute('data-dfndr-notify-open')) return;
      var isTrigger = el.classList && el.classList.contains('klaviyo-bis-trigger');
      if (!isTrigger) {
        if (el.children.length > 1) return;
        var t = (el.textContent || '').trim().toUpperCase().replace(/\s+/g, ' ');
        if (t !== 'NOTIFY ME WHEN AVAILABLE') return;
      }
      el.dataset.dfndrSuppressed = '1';
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function openModal(key) {
    var m = modal(key); if (!m) return;
    delete stateByKey[key];   /* fresh preselect from the live PDP variant */
    renderModal(key);
    m.hidden = false;
    document.documentElement.classList.add('dfndr-notify-open');
    var em = m.querySelector('[data-dfndr-notify-email]');
    if (em && !m.dataset.done) setTimeout(function () { em.focus(); }, 60);
  }
  function closeModals() {
    document.querySelectorAll('[data-dfndr-notify]').forEach(function (m) { m.hidden = true; });
    document.documentElement.classList.remove('dfndr-notify-open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest && t.closest('[data-dfndr-notify-open]');
    if (open) { openModal(open.getAttribute('data-key')); return; }
    var close = t.closest && t.closest('[data-dfndr-notify-close]');
    if (close) { closeModals(); return; }

    var m = t.closest && t.closest('[data-dfndr-notify]');
    if (!m) return;
    var key = m.getAttribute('data-key');
    var st = stateByKey[key];

    var oBtn = t.closest('[data-dfndr-opt]');
    if (oBtn && st) {
      st.sel[oBtn.getAttribute('data-dfndr-opt')] = oBtn.getAttribute('data-dfndr-val'); /* single-select */
      renderModal(key); return;
    }
    var btn = t.closest('[data-dfndr-notify-submit]');
    if (btn) submit(key, m, btn);
  });

  function post(url, body) {
    return fetch(url + '?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    });
  }

  function submit(key, m, btn) {
    var p = product(key);
    var email = m.querySelector('[data-dfndr-notify-email]');
    var msg = m.querySelector('[data-dfndr-notify-msg]');
    var addr = (email.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(addr)) {
      msg.textContent = 'Enter a valid email.';
      msg.className = 'dfndr-notify__msg is-err';
      return;
    }
    var v = resolve(key);
    if (!v) {
      msg.textContent = 'That combination isn\u2019t offered \u2014 adjust your picks.';
      msg.className = 'dfndr-notify__msg is-err';
      return;
    }
    if (v.a && !p.coming) {
      msg.textContent = 'Good news \u2014 that one\u2019s in stock. Close this and add it to cart.';
      msg.className = 'dfndr-notify__msg is-ok';
      return;
    }
    btn.disabled = true; btn.textContent = 'SAVING\u2026';

    var calls = [
      post('https://a.klaviyo.com/client/back-in-stock-subscriptions/', {
        data: {
          type: 'back-in-stock-subscription',
          attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: addr } } } },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
        }
      })
    ];
    if (LIST_ID && LIST_ID.length < 10) {
      calls.push(post('https://a.klaviyo.com/client/subscriptions/', {
        data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: addr, properties: {
            waitlist_product: p.title, waitlist_variant: v.o.join(' / ')
          } } } } },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      }));
    }
    Promise.all(calls).then(function (rs) {
      var ok = rs.every(function (r) { return r.status >= 200 && r.status < 300; });
      if (!ok) throw new Error('klaviyo');
      m.dataset.done = '1';
      ['.dfndr-notify__row', '.dfndr-notify__steps', '.dfndr-notify__opts', '.dfndr-notify__count']
        .forEach(function (s) { var el = m.querySelector(s); if (el) el.style.display = 'none'; });
      msg.textContent = "You're on the list for " + p.title + ' \u2014 ' + v.o.join(' / ') + ". One email the second it's live.";
      msg.className = 'dfndr-notify__msg is-ok';
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'NOTIFY ME';
      msg.textContent = "Couldn't save that \u2014 try again.";
      msg.className = 'dfndr-notify__msg is-err';
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[data-type="add-to-cart-form"], variant-picker, .variant-option')) {
      setTimeout(refresh, 60);
    }
  });
  document.addEventListener('variant:change', function () { setTimeout(refresh, 60); });
  document.addEventListener('DOMContentLoaded', refresh);
  setInterval(refresh, 800);
  refresh();
})();
